<div 
  *ngIf="showConstructionModal"
  class="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/50"
  (click)="closeConstructionModal()"
>
  <div 
    class="bg-white rounded-3xl w-full max-w-md relative py-6 px-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón cerrar -->
    <button
      type="button"
      class="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-neutral-gray-900 hover:bg-neutral-gray-100 rounded-lg transition"
      (click)="closeConstructionModal()"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>

    <!-- Icono En Construcción -->
    <div class="flex justify-center mb-6">
      <img src="assets/icons/system-error.svg" alt="En construcción" class="w-32 h-32" />
    </div>

    <!-- Título -->
    <h2 class="text-[20px] font-poppins font-bold text-neutral-gray-900 text-center mb-4">
      En construcción...
    </h2>

    <!-- Descripción -->
    <div class="text-center mb-6 text[14px]">
      <p class="text-[14px] font-normal font-poppins text-neutral-gray-700 mb-2">
        {{ description }}
      </p>
      <p class="text-[14px] font-normal font-poppins text-neutral-gray-700">
        {{ descriptionSecondary }}
      </p>
    </div>

    <!-- Botón Entendido -->
    <button
      type="button"
      class="w-full h-14 rounded-xl font-poppins font-bold text-white transition-colors hover:opacity-95 bg-cantera-red-primary"
      (click)="closeConstructionModal()"
    >
      Entendido
    </button>
  </div>
</div>